"use client";
import { PiShoppingCart } from "react-icons/pi";
import { useCart } from "./CartContext";
import { getCartNumberOfItems } from "./selectors";
import classNames from "classnames";

export function OpenCartButton() {
  const { openCart, cart } = useCart();
  const numberOfItems = getCartNumberOfItems(cart);
  return (
    <button
      onClick={openCart}
      data-item-count={numberOfItems}
      className={classNames("relative", {
        "before:absolute before:-right-2 before:bottom-0 before:flex before:h-4 before:w-4 before:items-center before:justify-center before:rounded-full before:bg-red-500 before:cvr-title-xs before:text-white before:content-[attr(data-item-count)]":
          numberOfItems > 0,
      })}
    >
      <span className="sr-only">{`Se handlevogn - ${numberOfItems} vare${
        numberOfItems > 1 ? "r" : ""
      }`}</span>
      <PiShoppingCart size={24} />
    </button>
  );
}
